<!-- Breadcrumd UI -->
<div class="container">
  <div class="table-background">
    <div class="row">
      <div class="search-row">
        <form role="search" class="em-c-search-form filterFormClass" [formGroup]="labTestFilterForm">
          <div class="em-c-search__body">
            <input id="search" type="search" class="em-c-search__input" placeholder="Search by keywords" value=""
              formControlName="search" />
            <button class="em-c-btn em-c-btn--primary search" aria-label="Search">
              <div class="em-c-btn__inner">
                <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/16/em-icons.svg#search"></use>
                </svg>
              </div>
            </button>
          </div>

          <div class="em-c-field searchDropdown">
            <label for="select" class="em-c-field__label" id="labelSelect">Well:</label>
            <div class="em-c-field__body">
              <select class="em-c-select wellSelect" [(ngModel)]="wellValue" id="well" aria-labelledby="labelSelect"
                aria-describedby="descSelect" placeholder="Select well" formControlName="well">
                @for (well of wellsLookup; track $index) {
                <option [value]="well">{{well}}</option>
                }
              </select>
            </div>
          </div>

          <div class="em-c-field searchDropdown">
            <label for="select" class="em-c-field__label" id="labelSelect">Sample status:</label>
            <div class="em-c-field__body">
              <select class="em-c-select statusSelect" [(ngModel)]="labtestStatusValue" id="labtestStatus"
                aria-labelledby="labelSelect" aria-describedby="descSelect" placeholder="Select status"
                formControlName="labtestStatus">
                @for (status of labtestStatusLookup; track $index) {
                <option [value]="status.statusName">{{status.statusName}}
                </option>
                }
              </select>
            </div>
          </div>

          <div class="em-c-field searchDropdown">
            <label for="select" class="em-c-field__label" id="labelSelect">Experiment Status:</label>
            <div class="em-c-field__body">
              <select class="em-c-select statusSelect" [(ngModel)]="experimentStatusValue" id="experimentStatus"
                aria-labelledby="labelSelect" aria-describedby="descSelect" placeholder="Select status"
                formControlName="experimentStatus">
                @for (status of experimentStatusLookup; track $index){
                <option [value]="status.statusName">{{status.statusName}}
                </option>
                }
              </select>
            </div>
          </div>

          <div class="em-c-field em-c-field--small searchDropdown" formGroupName="dateRange">
            <label for="dateRange" class="em-c-field__label">Date range:</label>
            <div class="em-c-field__body">
              <mat-form-field appearance="outline" class="datepicker">
                <mat-date-range-input [rangePicker]="rangepicker">
                  <input matStartDate placeholder="Start date" class="datepickerClass" id="startDateInput"
                    formControlName="start" readonly>
                  <input matEndDate placeholder="End date" class="datepickerClass" id="endDateInput"
                    formControlName="end" readonly>
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="rangepicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangepicker></mat-date-range-picker>
              </mat-form-field>
            </div>
          </div>

          <button class="em-c-btn em-c-btn--secondary em-c-btn--small resetButton" (click)="ResetFilters()">
            <span class="em-c-btn__text">Reset filters</span>
          </button>
          <!-- Changes for new Add Sample Page-->
          @if (roleId === roleIds.fluidEngineer) {
          <button class="em-c-btn em-c-btn--primary em-js-modal-trigger add-sample ml-5 disable-edit-add"
            (click)="NavigateCreateSample($event)">
            <div class="em-c-btn__inner">
              <span class="em-c-btn__text">Create new sample</span>
            </div>
          </button>
          }
        </form>
      </div>
    </div>
    <div class="main-table overflow-auto">
      <table id="lab-list-table" class="em-c-table t-body-height" matSort mat-table #table [dataSource]="dataSource"
        matSortActive="name" matSortDirection="asc" #outerSort="matSort" multiTemplateDataRows>
        <ng-container matColumnDef="wellName">
          <mat-header-cell *matHeaderCellDef mat-sort-header="wellName">
            Well
          </mat-header-cell>
          <mat-cell *matCellDef="let element; let i = dataIndex"
            [class.example-element-row]="element.labTestRepeat?.length"
            [class.example-expanded-row]="expandedElement === element" (click)="ToggleRow(element, i)" class="toggle">
            <svg class="em-c-icon em-c-icon--small em-c-table__icon right-chevron"
              [ngClass]="{ 'rotated': expandedElement === element }">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/16/em-icons.svg#chevron-right-filled">
              </use>
            </svg>
            {{ element.wellName }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="cylinder">
          <mat-header-cell *matHeaderCellDef mat-sort-header="cylinder">
            Sample
          </mat-header-cell>
          <mat-cell *matCellDef="let element" [class.example-element-row]="element.labTestRepeat?.length"
            [class.example-expanded-row]="expandedElement === element" (click)="ToggleRow(element, null)">
            {{ element.cylinder }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="samplingTypeName">
          <mat-header-cell *matHeaderCellDef mat-sort-header="samplingTypeName">Sampling type</mat-header-cell>
          <mat-cell *matCellDef="let element" [class.example-element-row]="element.labTestRepeat?.length"
            [class.example-expanded-row]="expandedElement === element" (click)="ToggleRow(element, null)">
            <span class="text-overflow">
              {{ element?.samplingTypeName }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="createdBy">
          <mat-header-cell *matHeaderCellDef mat-sort-header="createdBy">
            Created by
          </mat-header-cell>
          <mat-cell *matCellDef="let element" [class.example-element-row]="element.labTestRepeat?.length"
            [class.example-expanded-row]="expandedElement === element" (click)="ToggleRow(element, null)">
            {{ element.sampleCreatedBy }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="statusName">
          <mat-header-cell *matHeaderCellDef mat-sort-header="statusName">
            Status
          </mat-header-cell>
          <mat-cell class="status-cell" *matCellDef="let element"
            [class.example-element-row]="element.labTestRepeat?.length"
            [class.example-expanded-row]="expandedElement === element" (click)="ToggleRow(element, null)">
            <span class="em-c-badge" [ngClass]="(element?.statusName).toUpperCase()=== STATUS_CONSTANTS_UC.Completed
            ? 'em-c-badge em-c-badge--positive'
            : (element?.statusName).toUpperCase() === STATUS_CONSTANTS_UC.Ready
            ? 'em-c-badge--ready'
            :'em-c-badge em-c-badge--caution'" role="status" tabindex="0"
              [attr.aria-label]="(element?.statusName).toUpperCase()">
              {{ element?.statusName | uppercase }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
          <mat-cell *matCellDef="let element" [class.example-element-row]="element.labTestRepeat?.length"
            [class.example-expanded-row]="expandedElement === element">
            <button class="em-c-btn action-button action-button-disabled disable-edit-add" aria-label="Icon button"
              [title]="roleId === roleIds.techResource ? 'View sample' : 'Edit sample'"
              (click)="onEditSample(element.labTestId)">
              <div class="em-c-btn__inner">
                @if (roleId !== roleIds.techResource) {
                <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/edit-icon/em-edit-icon.svg"></use>
                </svg>
                }
                @if (roleId === roleIds.techResource) {
                <svg width="16px" height="16px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor" class="bi bi-eye">
                  <path
                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                  <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                </svg>
                }
              </div>
            </button>
            @if(roleId===roleIds.labTech || roleId === roleIds.techResource){
            <button class="em-c-btn action-button action-button-disabled" aria-label="Icon button" title="Complete Test"
              (click)="CompleteSample(element)"
              [disabled]="(roleId===roleIds.labTech || roleId === roleIds.techResource)">
              <div class="em-c-btn__inner">
                <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/16/em-icons.svg#check"></use>
                </svg>
              </div>
            </button>}
            @else {
            <button class="em-c-btn action-button" aria-label="Icon button" title="Complete Test"
              (click)="CompleteSample(element)">
              <div class="em-c-btn__inner">
                <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/16/em-icons.svg#check"></use>
                </svg>
              </div>
            </button>
            }
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
          <mat-cell *matCellDef="let element" [attr.colspan]="displayColumns.length">
            @if (element.labTestRepeat?.length) {
            <div [@detailExpand]="
                element === expandedElement ? 'expanded' : 'collapsed'
              ">
              @if (expandedElement) {
              <div class="inner-table">
                <table class="em-c-table t-body-inner-height" mat-table
                  [dataSource]="element.filteredSampleIdentifierGroups ?? []" multiTemplateDataRows>
                  <ng-container matColumnDef="identifierIndex">
                    <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                    <mat-cell *matCellDef="let identifier; let i = dataIndex"
                      (click)="ToggleIdentifierRow(element, identifier, $event)">
                      <svg class="em-c-icon em-c-icon--small em-c-table__icon right-chevron"
                        [ngClass]="{ 'rotated': IsIdentifierExpanded(element.labTestId, identifier.sampleIdentifier) }">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink"
                          xlink:href="images/16/em-icons.svg#chevron-right-filled">
                        </use>
                      </svg>
                      <!-- {{ i + 1 }} -->
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="sampleIdentifier">
                    <mat-header-cell *matHeaderCellDef>Sample Identifier</mat-header-cell>
                    <mat-cell *matCellDef="let identifier" (click)="ToggleIdentifierRow(element, identifier, $event)">
                      {{ identifier.sampleIdentifier }}
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="experimentsCount">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let identifier" (click)="ToggleIdentifierRow(element, identifier, $event)">
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="identifierExpandedDetail">
                    <mat-cell *matCellDef="let identifier" [attr.colspan]="identifierDisplayedColumns.length">
                      @if (IsIdentifierExpanded(element.labTestId, identifier.sampleIdentifier)) {
                      <div class="inner-table">
                        <table class="em-c-table t-body-inner-height" #innerTables mat-table #innerSort="matSort"
                          [dataSource]="identifier.filteredLabTestRepeat ?? identifier.labTestRepeat" matSort>
                          <ng-container matColumnDef="experimentName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="experimentName">
                              Experiment
                            </mat-header-cell>
                            <mat-cell class="experiment-name" *matCellDef="let exp">
                              @if(exp.labTestRepeatId!==0){
                              {{ (exp.experimentName?.trim()?.toLowerCase() === 'cce')
                              ? reportConstants.experimentNameCCEBubblePoint
                              : exp.experimentName }}
                              @if (expNamesShowTemp.has(exp.experimentName) && exp.conditionalTemp !== null) {
                              <ng-container>
                                at&nbsp;{{ exp.conditionalTemp }}F
                              </ng-container>
                              }
                              }
                            </mat-cell>
                          </ng-container>
                          <ng-container matColumnDef="experimentSequenceNo">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="experimentSequenceNo">
                              Experiment Sequence
                            </mat-header-cell>
                            <mat-cell *matCellDef="let exp">
                              @if(exp.labTestRepeatId!==0){
                              {{ exp.experimentSequenceNo }}
                              }
                            </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="assignedTo">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="assignedTo">
                              Assigned to
                            </mat-header-cell>
                            <mat-cell *matCellDef="let exp">
                              @if(exp.labTestRepeatId!==0){
                              {{ exp.assignedTo }}
                              }
                            </mat-cell>
                          </ng-container>
                          <ng-container matColumnDef="createdBy">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="createdBy">Created by</mat-header-cell>
                            <mat-cell *matCellDef="let exp">
                              @if(exp.labTestRepeatId!==0){
                              {{ exp.experimentCreatedBy }}
                              }
                            </mat-cell>
                          </ng-container>
                          <ng-container matColumnDef="statusName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="statusName"
                              class="expStatus">Status</mat-header-cell>
                            <mat-cell *matCellDef="let exp">
                              @if(exp.labTestRepeatId!==0){
                              <span class="em-c-badge experimentstatus" [ngClass]="(exp?.statusName).toUpperCase() === STATUS_CONSTANTS_UC.Rejected
                                    ? 'em-c-badge--negative'
                                    : (exp?.statusName).toUpperCase()  === STATUS_CONSTANTS_UC.Accepted 
                                    ? 'em-c-badge--accepted'
                                    : (exp?.statusName).toUpperCase() === STATUS_CONSTANTS_UC.Executed
                                    ? 'em-c-badge--executed'
                                    : (exp?.statusName).toUpperCase() === STATUS_CONSTANTS_UC.UnderExecution
                                    ? 'em-c-badge--caution'
                                    : (exp?.statusName).toUpperCase() === STATUS_CONSTANTS_UC.Ready
                                    ? 'em-c-badge--ready'
                                    : ''" role="status" tabindex="0"
                                [attr.aria-label]="(exp?.statusName).toUpperCase()">
                                {{ exp?.statusName | uppercase }}
                              </span>
                              }
                            </mat-cell>
                          </ng-container>
                          <ng-container matColumnDef="action">
                            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                            <mat-cell class="inner-action-button" *matCellDef="let exp"
                              (click)="$event.stopPropagation()">
                              @if(exp.labTestRepeatId!==0){
                              @if(roleId===roleIds.labTech){
                              <button class="em-c-btn" aria-label="Icon button" [ngClass]="((exp.statusName).toUpperCase()===STATUS_CONSTANTS_UC.Executed||
                                    (exp.statusName).toUpperCase()===STATUS_CONSTANTS_UC.Rejected||
                                    (exp.statusName).toUpperCase()===STATUS_CONSTANTS_UC.Accepted)
                                    ?'em-c-btn--disabled':''" [disabled]=""
                                (click)="NavigateExperiment(exp,roles.labTech, true)">
                                <div class="em-c-btn__inner">
                                  <svg class="em-c-icon em-c-icon--small  em-c-btn__icon" aria-hidden="true">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xlink:href="images/16/em-icons.svg#settings"></use>
                                  </svg>
                                  <span class="em-c-btn__text">Execute</span>
                                </div>
                              </button>
                              }
                              @if(roleId===roleIds.fluidEngineer){
                              @if((exp.statusName).toUpperCase()===STATUS_CONSTANTS_UC.Ready||
                              (exp.statusName).toUpperCase()===STATUS_CONSTANTS_UC.UnderExecution){
                              <button class="em-c-btn em-c-btn--disabled" [disabled]="">
                                <div class="em-c-btn__inner">
                                  <svg class="em-c-icon em-c-icon--small  em-c-btn__icon" aria-hidden="true">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xlink:href="images/16/em-icons.svg#settings"></use>
                                  </svg>
                                  <span class="em-c-btn__text">Execute</span>
                                </div>
                              </button>
                              }
                              @else if ((exp.statusName).toUpperCase()===STATUS_CONSTANTS_UC.Executed) {
                              <button class="em-c-btn" (click)="NavigateExperiment(exp,roles.fluidEngg, true)">
                                <div class="em-c-btn__inner">
                                  <svg class="em-c-icon em-c-icon--small  em-c-btn__icon" aria-hidden="true">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xlink:href="images/16/em-icons.svg#crosshairs"></use>
                                  </svg>
                                  <span class="em-c-btn__text">Review</span>
                                </div>
                              </button>
                              }
                              @else if
                              ((exp.statusName).toUpperCase()===STATUS_CONSTANTS_UC.Rejected||(exp.statusName).toUpperCase()===STATUS_CONSTANTS_UC.Accepted){
                              <button class="em-c-btn"
                                (click)="RepeatCCE(exp.labTestId,exp.labTestRepeatId,exp.sampleIdentifier)">
                                <div class="em-c-btn__inner">
                                  <svg class="em-c-icon em-c-icon--small  em-c-btn__icon" aria-hidden="true">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xlink:href="images/16/em-icons.svg#repeat">
                                    </use>
                                  </svg>
                                  <span class="em-c-btn__text">Repeat</span>
                                </div>
                              </button>
                              }
                              }
                              @if(roleId===roleIds.techResource){
                              <button class="em-c-btn em-c-btn--disabled" [ngClass]="((exp.statusName).toUpperCase()===STATUS_CONSTANTS_UC.Executed||
                                      (exp.statusName).toUpperCase()===STATUS_CONSTANTS_UC.Rejected||
                                      (exp.statusName).toUpperCase()===STATUS_CONSTANTS_UC.Accepted)
                                      ?'em-c-btn--disabled':''" [disabled]=""
                                (click)="NavigateExperiment(exp,roles.labTech, true)">
                                <div class="em-c-btn__inner">
                                  <svg class="em-c-icon em-c-icon--small  em-c-btn__icon" aria-hidden="true">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xlink:href="images/16/em-icons.svg#settings"></use>
                                  </svg>
                                  <span class="em-c-btn__text">Execute</span>
                                </div>
                              </button>
                              }
                              }
                            </mat-cell>
                          </ng-container>
                          <thead>
                            <mat-header-row *matHeaderRowDef="innerDisplayedColumns"></mat-header-row>
                          </thead>
                          @if(roleId===roleIds.labTech){
                          <mat-row (click)="NavigateExperiment(row,roles.labTech, false)"
                            *matRowDef="let row;columns: innerDisplayedColumns;let i = index">
                          </mat-row>
                          }
                          @else if (roleId===roleIds.fluidEngineer) {
                          <mat-row (click)="NavigateExperiment(row,roles.fluidEngg, false)"
                            *matRowDef="let row;columns: innerDisplayedColumns;let i = index">
                          </mat-row>
                          }
                          @else if (roleId===roleIds.techResource) {
                          <mat-row (click)="NavigateExperiment(row,roles.techResource, false)"
                            *matRowDef="let row;columns: innerDisplayedColumns;let i = index">
                          </mat-row>
                          }
                        </table>
                      </div>
                      }
                    </mat-cell>
                  </ng-container>

                  <thead>
                    <mat-header-row *matHeaderRowDef="identifierDisplayedColumns"></mat-header-row>
                  </thead>
                  <mat-row *matRowDef="let identifier; columns: identifierDisplayedColumns"></mat-row>
                  <mat-row *matRowDef="let identifier; columns: ['identifierExpandedDetail']"
                    [ngClass]="IsIdentifierExpanded(element.labTestId, identifier.sampleIdentifier) ? '' : 'no-display'">
                  </mat-row>
                </table>
              </div>
              }
            </div>
            }
          </mat-cell>
        </ng-container>
        <thead>
          <mat-header-row *matHeaderRowDef="displayColumns"></mat-header-row>
        </thead>
        <mat-row *matRowDef="let element; columns: displayColumns"></mat-row>
        <mat-row *matRowDef="let row; columns: ['expandedDetail']; let i = index"
          [ngClass]="row === expandedElement ? '' : 'no-display'"></mat-row>
      </table>
      <div class="paginator">
        <mat-paginator #paginator [length]="dataSource.data.length" [pageSize]="pageEvent.pageSize"
          [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
        </mat-paginator>
      </div>
    </div>
    <div>
      <canvas id="bubblePointChart" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="bubblePointChart1" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="bubblePointChart2" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="bubblePointChart3" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="bubblePointChart4" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="plotOilChart1" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="plotOilChart2" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="MatarialBalance" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="MatarialBalanceResult" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="HoffmanFactor" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="HoffmanFactorResult" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="ViscosityChart" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="cceDewPointChart1" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="cceDewPointChart2" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="decontDeadOilChart" class="decontamination"
        [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="decontliveFluidChart" class="decontamination"
        [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="summaryOfCCEChart" [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
      <canvas id="swellingChart" class="swellingChart"
        [ngStyle]="{ display: graphDisplay ? 'block' : 'none' }"></canvas>
    </div>
  </div>
</div>